<template>
  <div class="project-cases">
    <!-- Hero Section -->
    <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <div class="content-left">
            <h1 class="hero-title">项目案例</h1>
           
            <p class="hero-description">
              我们为石油化工、电力能源、消防应急、冶金制造等行业的客户提供专业的检测服务，积累了丰富的项目经验，建立了完善的服务体系。
            </p>
            <button class="btn-primary" @click="consultProject">咨询项目方案</button>
          </div>
          <div class="content-right">
            <div class="hero-image">
              <img src="@/assets/project-cases/image-1.png" alt="项目案例" class="hero-bg" />
              <div class="badge">
                <img src="@/assets/project-cases/image-2.png" alt="图标" class="badge-icon" />
                <span>行业领先</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 行业解决方案 Section -->
    <section class="solutions-section">
      <div class="container">
        <h2 class="section-title">行业解决方案</h2>
        <div class="solutions-grid">
          <div class="solution-card">
            <div class="solution-icon">
              <img src="@/assets/project-cases/image-5.png" alt="消防应急" />
            </div>
            <h3 class="solution-title">消防应急</h3>
            <p class="solution-desc">为空气呼吸器、气瓶等消防装备提供专业检测服务</p>
            <div class="solution-tags">
              <span class="tag">呼吸器检测</span>
              <span class="tag">气瓶检验</span>
              <span class="tag">气体检测仪</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 精选案例 Section - 暂时隐藏 -->
    <section class="cases-section" style="display: none;">
      <div class="container">
        <h2 class="section-title">精选案例</h2>
        <div class="cases-grid">
          <div 
            v-for="projectCase in cases" 
            :key="projectCase.id" 
            class="case-card"
          >
            <div class="case-image">
              <img :src="projectCase.image" :alt="projectCase.title" />
            </div>
            <div class="case-content">
              <div class="case-header">
                <h3 class="case-title">{{ projectCase.title }}</h3>
                <span class="status" :class="projectCase.status === '已完成' ? 'status-completed' : 'status-ongoing'">
                  {{ projectCase.status }}
                </span>
              </div>
              <p class="case-desc">
                {{ projectCase.description }}
              </p>
              <div class="case-tags">
                <span class="tag" v-for="tag in projectCase.tags" :key="tag">{{ tag }}</span>
              </div>
              <div class="case-footer">
                <img src="@/assets/project-cases/image-10.png" alt="时间" class="date-icon" />
                <span class="case-date">{{ projectCase.date }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="more-cases">
          <button class="btn-more" @click="viewMoreCases">
            <img src="@/assets/project-cases/image-11.png" alt="查看更多" class="btn-icon" />
            <span>查看更多案例</span>
          </button>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'ProjectCases',
  data() {
    return {
      cases: [
        {
          id: 1,
          title: 'XX石化公司空气呼吸器检测项目',
          image: require('@/assets/project-cases/image-7.png'),
          status: '已完成',
          description: '为XX石化公司提供全厂区500余套空气呼吸器的专业检测服务，确保员工在危险环境下的安全防护。',
          tags: ['空气呼吸器', '石化行业', '现场检测'],
          date: '2025年3月 - 2025年8月'
        },
        {
          id: 2,
          title: 'YY化工厂气体报警仪检测项目',
          image: require('@/assets/project-cases/image-8.png'),
          status: '已完成',
          description: '为YY化工厂提供全厂区气体报警仪的检测和校准服务，保障生产安全。',
          tags: ['气体报警仪', '化工行业', '校准服务'],
          date: '2025年1月 - 2025年6月'
        },
        {
          id: 3,
          title: 'ZZ电力公司气瓶检测项目',
          image: require('@/assets/project-cases/image-9.png'),
          status: '进行中',
          description: '为ZZ电力公司提供特种气瓶的定期检验服务，确保设备安全运行。',
          tags: ['气瓶检测', '电力行业', '定期检验'],
          date: '2025年1月 - 2025年12月'
        },
        {
          id: 4,
          title: 'ABC制药公司呼吸器检测服务',
          image: require('@/assets/project-cases/image-12.png'),
          status: '已完成',
          description: 'ABC制药公司提供压力容器、管道检测及安全附件校验等综合服务。',
          tags: ['呼吸器检测', '制药行业', '综合服务'],
          date: '2024年10月 - 2025年2月'
        }
      ]
    }
  },
  methods: {
    // 咨询项目方案
    consultProject() {
      this.$router.push('/contact')
    },
    
    // 查看更多案例
    viewMoreCases() {
      // 滚动到案例区域或实现分页功能
      const casesSection = document.querySelector('.cases-section')
      if (casesSection) {
        casesSection.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
/* 基础容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(90deg, #1e3a8a 0%, #1d4ed8 100%);
  color: white;
  height: 470px;
  position: relative;
  display: flex;
  align-items: center;
}

.hero-content {
  display: flex;
  align-items: center;
  gap: 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.content-left {
  flex: 1;
  max-width: 550px;
}

.content-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.hero-image {
  position: relative;
  width: 450px;
  height: 360px;
}

.hero-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.badge {
  position: absolute;
  bottom: -20px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.95);
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.badge-icon {
  width: 12px;
  height: 16px;
  object-fit: contain;
}

.badge span {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.hero-title {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 24px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 24px;
  opacity: 0.95;
}

.hero-description {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 32px;
  opacity: 0.9;
}

.btn-primary {
  background: white;
  color: #1e3a8a;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

/* 行业解决方案 Section */
.solutions-section {
  padding: 80px 0;
  background: #f8f9fa;
}

.section-title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 48px;
  color: #2c3e50;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.solution-card {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.solution-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.solution-icon {
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  background: #dbeafe;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.solution-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.solution-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #1f2937;
}

.solution-desc {
  font-size: 16px;
  color: #4b5563;
  line-height: 1.5;
  margin-bottom: 16px;
}

.solution-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  display: inline-block;
  background: #e8eaf6;
  color: #1e3a8a;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

/* 精选案例 Section */
.cases-section {
  padding: 80px 0;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 32px;
  margin-bottom: 48px;
}

@media (max-width: 1200px) {
  .cases-grid {
    grid-template-columns: 1fr;
  }
}

.case-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: row;
}

.case-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 30px -6px rgba(0, 0, 0, 0.15);
}

.case-image {
  width: 160px;
  height: 160px;
  flex-shrink: 0;
}

.case-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.case-content {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.case-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 12px;
}

.case-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.status {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-ongoing {
  background: #cce5ff;
  color: #004085;
}

.case-desc {
  font-size: 15px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 20px;
}

.case-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.case-footer {
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
}

.date-icon {
  width: 13px;
  height: 14px;
  object-fit: contain;
}

.case-date {
  font-size: 14px;
  color: #6b7280;
}

.more-cases {
  text-align: center;
  margin-top: 40px;
}

.btn-more {
  background: transparent;
  color: #1e3a8a;
  border: none;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-more .btn-icon {
  width: 15px;
  height: 16px;
  object-fit: contain;
}

.btn-more:hover {
  background: #f3f4f6;
  transform: translateY(-2px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 400px;
    padding: 80px 0 40px;
  }

  .hero-content {
    flex-direction: column;
    gap: 40px;
  }

  .content-left {
    max-width: 100%;
  }

  .content-right {
    width: 100%;
  }

  .hero-image {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 4/3;
  }

  .hero-title {
    font-size: 28px;
    line-height: 1.3;
    margin-bottom: 16px;
  }

  .hero-subtitle {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 16px;
  }

  .hero-description {
    font-size: 14px;
    line-height: 1.6;
    display: none;
  }

  .btn-primary {
    width: 100%;
    padding: 12px 24px;
  }

  .badge {
    bottom: -12px;
    right: -12px;
    padding: 6px 12px;
  }

  .badge span {
    font-size: 14px;
  }

  .badge-icon {
    width: 10px !important;
    height: 14px !important;
  }

  .section-title {
    font-size: 28px;
  }

  .solutions-grid,
  .cases-grid {
    grid-template-columns: 1fr;
  }

  .case-card {
    flex-direction: column;
  }

  .case-image {
    width: 100%;
    height: 200px;
  }

}
</style>

